  <template>
  <div style="padding: 0.5em">
    <div class="com-msg">
      <div class="com-name"><u>東港金属・本社工場</u></div>
      <el-form :model="form" ref="form" label-position="left" label-width="0" class="card-box-com-c">
        <el-row>
          <el-col :span="9"><div class="titleDetail-c"><span>{{systemName}}</span></div></el-col>
          <el-col :span="15"><div class="error-c"><span>{{errorMsg}}</span></div></el-col>
        </el-row>
        <el-table
          id="table"
          :data="tableData"
          border
          height = "700"
          style="width: 100%">
          <el-table-column
            prop="reserved_status"
            width="100"
            label="確認">
            <template slot-scope="scope">
              <el-select v-model="scope.row.reserved_status" clearable placeholder="選択" @change="changeOption(scope.$index, scope)">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="reserved_id"
            width="130"
            label="受付番号">
          </el-table-column>
          <el-table-column
            prop="company_name"
            label="会社名"
            show-overflow-tooltip
            width="140">
          </el-table-column>
          <el-table-column
            prop="truck_comp_name"
            label="運送会社名"
            show-overflow-tooltip
            width="164">
          </el-table-column>
          <el-table-column
            prop="truck_type_name"
            label="車両"
            show-overflow-tooltip
            width="164">
          </el-table-column>
          <el-table-column
            prop="truck_type_other"
            label="車両その他"
            show-overflow-tooltip
            width="164">
          </el-table-column>
          <el-table-column
            prop="reserved_ymd"
            label="搬入日時"
            show-overflow-tooltip
            width="164">
          </el-table-column>
          <el-table-column
            prop="item_type_name"
            label="搬入品目"
            show-overflow-tooltip
            width="164">
          </el-table-column>
          <el-table-column
            prop="item_other"
            label="搬入品目その他"
            show-overflow-tooltip
            width="164">
          </el-table-column>
          <el-table-column
            prop="truck_tel"
            label="夜間連絡先"
            show-overflow-tooltip
            width="164">
          </el-table-column>
          <el-table-column
            prop="prepare"
            label="備考"
            show-overflow-tooltip
            width="164">
          </el-table-column>
        </el-table>
        <div class = "pagination">
          <el-pagination
            background
            @current-change="changePage"
            layout="prev, pager, next"
            :page-size="limit"
            :current-page="currentPage"
            :total="total">
          </el-pagination>
        </div>
        <el-row >
          <el-col :span="21 ">
            <el-form-item >
              <el-button type="danger" class="btn-left" @click.native.prevent="handleSubmit2('form')">確　認</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item >
              <el-button type="danger" class="btn-left" @click.native.prevent="back()"><i class="el-icon-caret-right"style="color: white;"></i> 戻　る </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
  import http from '../../assets/js/http'
  import _g from '../../assets/js/global'
  import timeChe from '../../assets/js/timeChe'

  export default {
    data () {
      return {
        systemName: '取引先向け会社別搬入情報一覧',
        errorMsg: '',
        fromDate: '',
        toDate: '',
        userId: '',
        total: null,
        limit: 10,
        errorFlg: false,
        errorFlg2: false,
        currentPage: null,
        tableData: [],
        tableData1: [],
        form: {
          status: 0,
          value: ''
        },
        options: [{
          value: '0',
          label: '取消'
        },
        {
          value: '2',
          label: ' '
        },
        {
          value: '6',
          label: '削除'
        }]
      }
    },
    methods: {
      handleSubmit2(form) {
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.indexOf('msie') != -1 || ua.indexOf('trident/7') != -1) {
          if (window.event.which == 13) {
            return false
          }
        }
        if (this.errorFlg === false && this.errorFlg2 === false) {
          let data = {}
          var date = new Date()
          data.dataList = this.tableData
          data.userId = this.$route.query.userId
          var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
          var day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
          var upDate = date.getFullYear().toString() + month + day
          data.upDate = upDate
          this.apiPost('customer/CompanyList/confirmHandle', data).then((res) => {
            this.handelResponse(res, (data) => {
              if (res.code != 200) {
                this.loading = !this.loading
                this.handleError(res)
              } else {
                if (data.dataCount === '0') {
                  _g.toastMsg('error', '変更がありません！')
                } else {
                  _g.toastMsg('success', '変更のデータを更新しました！')
                  this.tableData = []
                  this.total = 0
                  this.init()
                }
              }
            })
          })
        } else if (this.errorFlg === true) {
          _g.toastMsg('error', '過去予約の情報を修正は不可')
        } else if (this.errorFlg2 === true) {
          _g.toastMsg('error', '19時を過ぎたので、変更できません。')
        }
      },
      reDays(date, value) {
        // date.setDate(date.getDate() + value)
        var newDate = new Date(date.getTime() - 3600 * 1000 * 24 * value)
        return newDate
      },
      changeOption(index, scope) {
        var y = scope.row.reserved_ymd.substr(0, 4).toString()
        var m = scope.row.reserved_ymd.substr(5, 2).toString()
        var d = scope.row.reserved_ymd.substr(8, 2).toString()
        var date = new Date()
        var hms = date.getHours().toString()
        if (hms >= 8) {
          date = this.reDays(date, 1)
        }
        var sy = date.getFullYear().toString()
        var sm = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
        var sd = (date.getDate() + 1) < 10 ? '0' + (date.getDate() + 1).toString() : (date.getDate() + 1).toString()
        hms = date.getHours().toString()
        var table = document.getElementById('table')
        var rows = table.getElementsByTagName('tr')
        var cells = rows[index + 1].getElementsByTagName('td')
        var div = cells[0].getElementsByTagName('div')
        var isCheck = true
        this.tableData1.forEach(function (item, index, input) {
          if (item.reserved_id === scope.row.reserved_id) {
            if (scope.row.reserved_status === item.status) {
              isCheck = false
            }
          }
        })
        if (isCheck === true) {
          console.log(y + m + d)
          console.log(sy + sm + sd)
          if ((y + m + d) < (sy + sm + sd)) {
            div[1].style.border = '1px solid #f56c6c'
            _g.toastMsg('error', '過去予約の情報を修正は不可')
            this.errorMsg = '過去予約の情報を修正は不可'
            this.errorFlg = true
          } else if ((y + m + d) === (sy + sm + sd)) {
            if (hms >= 19) {
              if (scope.row.reserved_status !== '0') {
                _g.toastMsg('error', '19時を過ぎたので、変更できません。')
                div[1].style.border = '1px solid #f56c6c'
                this.errorMsg = '19時を過ぎたので、変更できません。'
                this.errorFlg2 = true
              } else {
                div[1].style.border = '0px'
                this.errorFlg = false
                this.errorFlg2 = false
                this.errorMsg = ''
                this.tableData[index].reserved_status = scope.row.reserved_status
              }
            }
          } else {
            div[1].style.border = '0px'
            this.errorFlg = false
            this.errorFlg2 = false
            this.errorMsg = ''
            this.tableData[index].reserved_status = scope.row.reserved_status
          }
        } else {
          div[1].style.border = '0px'
          this.errorFlg = false
          this.errorFlg2 = false
          this.errorMsg = ''
          this.tableData[index].reserved_status = scope.row.reserved_status
        }
      },
      back() {
        // window.history.back()
        this.$router.push({ path: '/customer/search', query: { radio: this.$route.query.radio, fromDate: this.fromDate, toDate: this.toDate }})
      },
      changePage(currentPage) {
        if (this.errorFlg === false && this.errorFlg2 === false) {
          let data = {}
          var date = new Date()
          data.dataList = this.tableData
          data.userId = this.$route.query.userId
          var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
          var day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
          var upDate = date.getFullYear().toString() + month + day
          data.upDate = upDate
          this.apiPost('customer/CompanyList/confirmHandle', data).then((res) => {
            this.handelResponse(res, (data) => {
              if (res.code != 200) {
                this.loading = !this.loading
                this.handleError(res)
              } else {
                this.$router.push({ path: this.$route.path, query: { fromDate: this.fromDate, toDate: this.toDate, userId: this.userId, currentPage: currentPage }})
                if (data.dataCount === '0') {
                } else {
                  _g.toastMsg('success', '変更のデータを更新しました！')
                  this.tableData = []
                  this.total = 0
                  this.init()
                }
              }
            })
          })
        } else if (this.errorFlg === true) {
          _g.toastMsg('error', '過去予約の情報を修正は不可')
        } else if (this.errorFlg2 === true) {
          _g.toastMsg('error', '19時を過ぎたので、変更できません。')
        }
      },
      getAllUsers() {
        let data = {}
        data.fromDate = this.$route.query.fromDate
        data.toDate = this.toDate = this.$route.query.toDate
        data.userId = this.userId = this.$route.query.userId
        data.page = this.currentPage
        data.limit = this.limit
        this.apiPost('customer/CompanyList/companyList', data).then((res) => {
          this.handelResponse(res, (data) => {
            if (res.code != 200) {
              this.loading = !this.loading
              this.handleError(res)
            } else {
              var dataList = data.list
              var reData = dataList.forEach(function (val, index, arr) {
                if (val.reserved_status === '1') {
                  val.reserved_status = '2'
                }
                return val
              })
              let dataList1 = data.list
              this.tableData1 = data.list
              var b = data.list.forEach(function (item, index, input) {
                // dataList1[index].truck_tel = item.truck_tel_siban + '-' + item.truck_tel_kaiban + '-' + item.truck_tel_kyokuban
                if ((item.truck_tel_kaiban === '' || item.truck_tel_kaiban === null) && (item.truck_tel_kyokuban === '' || item.truck_tel_kyokuban === null)) {
                  dataList1[index].truck_tel = item.truck_tel_siban
                } else {
                  dataList1[index].truck_tel = item.truck_tel_siban + '-' + item.truck_tel_kaiban + '-' + item.truck_tel_kyokuban
                }
                // if (item.ITEM_TYPE_CD === '10011') {
                //   dataList1[index].item_other = item.item_other
                // } else {
                //   dataList1[index].item_other = ''
                // }
                dataList1[index].reserved_ymd = item.reserved_ymd + '　' + timeChe.gettimeChe(item.reserved_time)
              })
              this.tableData = dataList1
              this.total = data.dataCount
            }
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.currentPage) {
            this.currentPage = parseInt(data.currentPage)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.fromDate) {
            this.fromDate = data.fromDate
          } else {
            this.fromDate = ''
          }
          if (data.toDate) {
            this.toDate = data.toDate
          } else {
            this.toDate = ''
          }
          if (data.userId) {
            this.userId = data.userId
          } else {
            this.userId = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllUsers()
      }
    },
    created() {
      this.fromDate = this.$route.query.fromDate
      this.toDate = this.$route.query.toDate
      this.userId = this.$route.query.userId
      let that = this
      setInterval(function() {
        this.tableData = []
        this.total = 0
        that.init()
      }, 5 * 60 * 1000)
      this.init()
    },
    mounted() {
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      // btnGroup
    },
    mixins: [http]
  }
</script>
<style>
  .card-box-com-c {
    padding: 1em;
  }
  .com-msg {
    -webkit-border-radius: 1em;
    border-radius: 0.5em;
    -moz-border-radius: 1em;
    background-clip: padding-box;
    background-color: #F9FAFC;
    margin: 1em auto;
    height: 57em;
    width: 107.3em;
    border: 0.1em solid #8492A6;
  }
  .com-name{
    text-align: right;
    padding: 0.5em;
    font-weight: bold;
    font-size: 1.3em;
  }
  .btn-left{
    float: right;
    width: 150px;
  }
  .pagination{
    width: 100%;
    text-align:center;
  }
  .titleDetail-c {
    color: #505458;
    font-weight: bold;
    font-size: 1.17em;
    padding: 0em 0em 1em 0.5em;
  }
  .error-c {
    color: #f56c6c;
  }
</style>



// WEBPACK FOOTER //
// src/components/customer/companyList.vue